/* eslint-disable @typescript-eslint/ban-ts-comment */
import { CommentInputAction, CommentInputState } from "./comment-input-state-types";
import { parseCommentTextContent } from "./comment-text-content-helpers";

export function commentInputReducer(state: CommentInputState, action: CommentInputAction) {
    switch (action.type) {
        case "update_text":
            return { ...state, text: action.text };
        case "update_images":
            return { ...state, images: action.images };
        default:
            // @ts-expect-error
            throw Error(`Unknown action: ${action.type}`);
    }
}

export const initialCommentInputState: CommentInputState = {
    text: "",
    images: [],
    doesCommentHaveExistingImage: false,
};

export function createInitialCommentInputState(commentTextContent: string): CommentInputState {
    const { commentImageIds, commentText } = parseCommentTextContent(commentTextContent);
    return {
        text: commentText,
        images: commentImageIds,
        doesCommentHaveExistingImage: commentImageIds.length > 0,
    };
}
